import {Component, Input, OnInit} from '@angular/core';
import { GadgetApiService, PageNotificationService } from '@signature-it/ngx-generic/services';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';

@Component({
    selector: 'list-gadget',
    templateUrl: './list.gadget.html',
    styleUrls: ['./list.gadget.scss'],
    standalone: false
})
export class ListGadget implements OnInit {
    @Input() key: string;
    @Input() url: string;

  data: Array<any>;
  beUrl: string;
  imagesPath: string;
  systemName: string;
  @Input() title: string;
  open = false;
  count = 0;

  constructor(
      protected gadgetApiSvc: GadgetApiService,
      protected notifySvc: PageNotificationService,
      protected restUrlsConf: RestUrlsConfig) {
      this.imagesPath =  GenericConfig.imagesPath;
      this.systemName =  GenericConfig.systemName;
  }

  ngOnInit() {
      this.beUrl = this.restUrlsConf.beURL;
      this.gadgetApiSvc.getListData(this.key, this.url)
        .subscribe(
            res => {
              if (res) {
                this.data = res;
              } else {
                this.notifySvc.set('Some Error Occurred').show();
              }
            },
            error => {
              this.notifySvc.set(error).show();
            }
        );
  }

}
